import { AssetCard } from "@10x/dubai-rest-api/dist/property_registry/entity";
import React, { MouseEvent, useEffect, useState } from "react";
import Strings from "@my-dld/assets/strings";
import { DetailsKV, extractPropInfo } from "@my-dld/screens/MyDLD/PropertyDetails";
import { PropertyCADInfo } from "@10x/dubai-rest-api/dist/gis/entity";
import * as SSO from "@10x/sso";
import { LocaleUtil } from "@eres/core";
import { getPropertyCADInfo } from "@10x/dubai-rest-api/dist/gis/api";
import { isEmptyStringOrNull } from "@eres/core/dist/StringUtils";

export function PropertyDrawing( props: { data: AssetCard } ) {
	const { data } = props;
	const [ cadInfo, setCADInfo ] = useState<PropertyCADInfo | undefined>( undefined );
	useEffect( () => {
		getPropertyCADInfo( data.propertyId ).then( ( response: PropertyCADInfo ) => {
			setCADInfo( response );
		} ).catch( e => {
			console.log( e );
		} );
	}, [] );

	const onViewImage = ( e: MouseEvent<HTMLAnchorElement> ) => {
		e.preventDefault();
		window.open( cadInfo?.imgUrl );
	};

	const getShareData = () => {
		let { lbl, val } = extractPropInfo( data );
		let info = `${ Strings.owner_name } : ${ LocaleUtil.getLocalValue( SSO.getName() ) }\n`;
		info += `${ lbl } : ${ val }\n`;
		info += `${ Strings.municipality_no } : ${ data.municipalityNo }\n`;
		if ( cadInfo ) {
			info += `${ Strings.autocad_file } : ${ cadInfo.imgUrl }\n`;
			info += `${ Strings.image_file } : ${ cadInfo.cadUrl }\n`;
		}
		return `mailto: ?subject=${ Strings.property_drawing }&body=${ encodeURIComponent( info ) }`;
	};

	if ( cadInfo && !isEmptyStringOrNull( cadInfo.imgUrl ) && !isEmptyStringOrNull( cadInfo.cadUrl ) ) {
		return <DetailsKV
			label={ Strings.property_drawing }
			valueRenderer={ () => {
				return <>
					<a href="#" className="underline" onClick={ onViewImage }>{ Strings.view_image }</a>
					<a
						href={ getShareData() }
						className="underline btn-sm">{ Strings.share_auto_cad }</a>
				</>;
			} }/>;
	}
	return null;
}
